import { default as ShopPremiumContent } from './ShopPremiumContent';
import ShopPremiumContentContainer from './ShopPremiumContent.container';

export default ShopPremiumContentContainer(ShopPremiumContent);
